import { toolbarClasses } from '@ahamove/web-components/lib/Toolbar';
import useScrollTrigger from '@ahamove/web-components/lib/useScrollTrigger';
import * as React from 'react';

interface Props {
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window?: () => Window;
  children: React.ReactElement;
  defaultElevation?: number | undefined;
}

export default function ElevationScroll(props: Props) {
  const { children, window, defaultElevation = 0 } = props;
  // Note that you normally won't need to set the window ref as useScrollTrigger
  // will default to window.
  // This is only being set here because the demo is in an iframe.
  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 0,
    target: window ? window() : undefined,
  });

  return React.cloneElement(children, {
    elevation: trigger ? 1 : defaultElevation,
    sx: trigger
      ? {
          [`.${toolbarClasses.root}`]: {
            border: 'none',
          },
        }
      : {},
  });
}
